<template>
  <div
    class="category-popup"
    :style="{
      height: isMobileView
        ? `${windowHeight}px`
        : `calc(100% - ${headerHeight}px)`,
      top: `${headerHeight}px`,
    }"
  >
    <div
      class="stories"
      :class="{ hidden: storiesHidden, 'hidden-active': storiesHiddenActive }"
      ref="storiesSlider"
    >
      <div
        v-for="(story, storyKey) in currentStories"
        :key="storyKey"
        :style="{ transitionDelay: `${(storyKey + 1) * 0.1}s` }"
        class="story-item"
        @click="goToStory(story)"
      >
        <div class="image" :style="{ backgroundImage: `url(${story.image})` }">
          <Dot class="story-title" :msg="story.title" :line="2"></Dot>
        </div>
      </div>
    </div>
    <div v-if="isMobileView" class="stories-arrows">
      <span class="stories-arrow-prev" @click="prevSlide"></span>
      <span class="stories-arrow-next" @click="nextSlide"></span>
    </div>
    <CategoriesList
      :class="{
        hidden: categoriesHidden,
        'hidden-active': categoriesHiddenActive,
      }"
    />
    <div class="back" @click="closeCategory">Назад</div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import CategoriesList from "./CategoriesList";
import Dot from "vue-text-dot";

export default {
  data() {
    return {
      categoriesHidden: true,
      categoriesHiddenActive: true,
      storiesHidden: true,
      storiesHiddenActive: true,
      currentSlide: 0,
      scrollAmount: 0,
    };
  },
  mounted() {
    this.handleTransitions(true, true);
  },
  computed: {
    ...mapState([
      "currentCategory",
      "categories",
      "stories",
      "headerHeight",
      "windowWidth",
      "windowHeight",
    ]),
    ...mapGetters(["isMobileView"]),
    currentStories() {
      if (!this.currentCategory) return;
      return this.stories
        .filter((s) => s.categoryId === this.currentCategory.id)
        .slice(0, 6);
    },
  },
  methods: {
    ...mapActions(["changeStory", "closeCategory"]),
    handleTransitions(categories, stories) {
      if (categories) {
        this.categoriesHidden = true;
        this.categoriesHiddenActive = true;
      }
      if (stories) {
        this.storiesHidden = true;
        this.storiesHiddenActive = true;
      }
      setTimeout(() => {
        this.categoriesHidden = false;
        this.storiesHidden = false;
        setTimeout(() => {
          this.categoriesHiddenActive = false;
          this.storiesHiddenActive = false;
        }, 1000);
      }, 500);
    },
    goToStory(story) {
      this.changeStory(
        this.stories.findIndex(
          (s) => s.categoryId === story.categoryId && s.title === story.title
        )
      );
      this.closeCategory();
    },
    changeSlide(index) {
      this.scrollAmount = 0;
      let scrollStep = Math.round(this.windowWidth / 110);
      let slideTimer = setInterval(() => {
        if (index < this.currentSlide) {
          this.$refs.storiesSlider.scrollLeft -= scrollStep;
        } else {
          this.$refs.storiesSlider.scrollLeft += scrollStep;
        }
        this.scrollAmount += scrollStep;
        if (
          this.scrollAmount >=
          this.$refs.storiesSlider.scrollWidth / this.currentStories.length
        ) {
          window.clearInterval(slideTimer);
          this.currentSlide = index;
        }
      }, 1);
    },
    prevSlide() {
      if (this.currentSlide <= 0) return;
      this.changeSlide(this.currentSlide - 1);
    },
    nextSlide() {
      if (this.currentSlide >= this.currentStories.length - 1) return;
      this.changeSlide(this.currentSlide + 1);
    },
  },
  components: { CategoriesList, Dot },
  watch: {
    currentCategory() {
      this.currentSlide = 0;
      this.handleTransitions(false, true);
    },
  },
};
</script>
<style lang="scss">
.category-popup {
  background: url("~@/assets/img/mainbg.jpg") no-repeat center;
  background-size: cover;
  position: absolute;
  width: 100vw;
  z-index: 80;
  display: flex;
  left: 0;
  .stories {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 8vh 0 8vh 5vw;
    margin-right: -6vw;
    .story-item {
      width: 18vw;
      height: 30vh;
      margin-right: 6vw;
      margin-bottom: 10vh;
      transition: 0.3s;
      cursor: pointer;
      &:nth-child(2n - 1) {
        transform: rotate(-7deg);
      }
      &:nth-child(2n) {
        transform: rotate(7deg);
      }
      &:hover {
        transform: scale(1.1) rotate(0deg);
      }
      .image {
        position: relative;
        width: 100%;
        height: 100%;
        background-size: contain;
        background-position: center;
        background-color: #ffffff;
        background-repeat: no-repeat;
        border: 1vw solid #fff;
        border-bottom-width: 3.4vw;
        box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);

        .story-title {
          position: absolute;
          top: 102%;
          font-size: 1vw;
          line-height: 1.2vw;
          width: 100%;
          text-align: center;
          color: #003274;
          font-weight: bold;
          p {
            margin: 0;
          }
        }
        &:before {
          content: "";
          top: -18px;
          left: -18px;
          position: absolute;
          width: 100%;
          height: 100%;
          transform: rotate(8deg);
          z-index: -1;
          background-color: #fff;
          border: 1vw solid #fff;
          border-bottom-width: 3.4vw;
          box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);
        }
        &:after {
          content: "";
          position: absolute;
          width: 3vw;
          height: 3vw;
          background-image: url("~@/assets/img/clip.png");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          top: -1.59vw;
          right: 0;
        }
      }
    }
    &.hidden {
      .story-item {
        opacity: 0;
        transform: rotate(0deg);
      }
    }
    &:not(.hidden-active) {
      .story-item {
        transition-delay: 0s !important;
      }
    }
  }
  .back {
    position: absolute;
    left: 70px;
    bottom: 40px;
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
    color: #0055bb;
    cursor: pointer;
    &:before {
      content: "";
      transform: rotate(180deg);
      background-image: url("~@/assets/img/arrow_b.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      position: absolute;
      height: 100%;
      width: 30px;
      top: 0;
      left: -30px;
    }
  }
}

#portrait .category-popup {
  top: 0 !important;
  padding-top: 90px;
  flex-direction: column-reverse;
  position: fixed;
  justify-content: center;
  .categories {
    height: calc(30vh - 90px);
  }
  .stories {
    max-height: 60vh;
    display: block;
    white-space: nowrap;
    padding: 50px 40px;
    overflow: hidden;
    position: relative;
    width: 70%;
    align-self: center;
    .story-item {
      display: inline-block;
      width: 100%;
      height: 100%;
      margin-right: 70px;
      margin-bottom: 0;
      .image {
        border-width: 10px;
        border-bottom-width: 60px;
        .story-title {
          white-space: normal;
          font-size: inherit;
          line-height: inherit;
        }
        &:before {
          border-width: 10px;
          border-bottom-width: 60px;
          transform: rotate(6deg);
        }
        &:after {
          content: none;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .stories-arrows {
    .stories-arrow-prev,
    .stories-arrow-next {
      position: fixed;
      top: calc(40vh - 45px + 30vh);
      z-index: 3;
      width: 35px;
      height: 35px;
      background-image: url("~@/assets/img/arrow_g.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      z-index: 3;
    }
    .stories-arrow-prev {
      transform: rotate(180deg);
      left: 5px;
    }
    .stories-arrow-next {
      right: 5px;
    }
  }
}

@media only screen and (max-width: 1600px) {
  .category-popup {
    .stories {
      .story-item {
        width: 16vw;
        height: 26vh;
        margin-right: 6vw;
        margin-bottom: 10vh;
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .category-popup {
    .stories {
      padding: 50px 0;
      .story-item {
        .image {
          &:before {
            top: -10px;
            left: -10px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .category-popup {
    .stories {
      .story-item {
        width: 150px;
        height: 150px;
        margin-right: 5.5vw;
        margin-bottom: 6vw;
        transform: rotate(0) !important;
        .image {
          border-bottom-width: 50px;
          &:before {
            top: -8px;
            left: -8px;
          }
          .story-title {
            font-size: 10px;
            line-height: 12px;
          }
        }
      }
    }
    .back {
      left: 40px;
      bottom: 20px;
      font-size: 16px;
      line-height: 18px;
    }
  }
}
@media only screen and (max-width: 480px) {
  #portrait .category-popup {
    .categories {
      height: calc(40vh - 90px);
    }
    .stories {
      padding: 30px 40px;
      width: 100%;
      align-self: auto;
      .story-item {
        height: 80%;
      }
    }
  }
}
</style>